import React, { createContext, Fragment, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AlertsContainer from "./components/AlertsContainer";
import FooterMain from "./components/footer/FooterMain";
import BackOffice from "./pages/admin/BackOffice";
import FrontOffice from "./pages/student/FrontOffice";
//import InProgress from "./InProgress";
import HomePage from "./pages/homePage/HomePage";
import NoMatch from "./pages/NoMatch";
import $ from "jquery";
import SetNewPassword from "./pages/SetNewPassword";
import ActivateAccount from "./pages/ActivateAccount";
import SessionAlert from "./components/SessionAlert";
import { useTranslation } from "react-i18next";
import { postMethod } from "./requests";
import ConfirmModal from "./components/modals/ConfirmModal";
import LoadingView from "./components/loadingView/LoadingView";
import { Alert, Button } from "react-bootstrap";
export const BasicContext = createContext();
var interval;

const App = () => {
    const { t } = useTranslation();
    const [alerts, setAlerts] = useState([]);
    const [theme, setTheme] = useState(null);
    const [isLogged, setIsLogged] = useState(null);
    const [noPermission, setNoPermission] = useState(null);
    const [showView, setShowView] = useState(null);
    const [viewsHistory, setViewsHistory] = useState([]);
    const [sessionAlert, setSessionAlert] = useState(null);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showCookieAlert, setShowCookieAlert] = useState(false);

    const routes = [
        {
            path: "/",
            element: <HomePage />,
            //element: <InProgress />,
        },
        {
            path: "/app",
            element: <FrontOffice />,
        },
        {
            path: "/admin-app",
            element: <BackOffice />,
        },
        {
            path: "/set-new-password",
            element: <SetNewPassword />,
        },
        {
            path: "/activate-account",
            element: <ActivateAccount />,
        },
        {
            path: "*",
            element: <NoMatch />,
        },
    ];

    useEffect(() => {
        if (theme) {
            const cookieTheme = localStorage.getItem("theme");
            if (cookieTheme !== theme) localStorage.setItem("theme", theme);
            $("body").removeClass();
            $("body").addClass(`${theme}-theme`);
        } else {
            const cookieTheme = localStorage.getItem("theme");
            if (!cookieTheme || cookieTheme === "null") {
                localStorage.setItem("theme", "light");
                setTheme("light");
            } else setTheme(cookieTheme);
        }
        // eslint-disable-next-line
    }, [theme]);

    const checkServerData = (res) => {
        if (res.status === 200) return true;
        else {
            if (res.status === 500) {
                setAlerts([{ variant: "danger", message: t(`error.${res.response.data.code.code}`) }]);
            } else if (res.status === 403) {
                setAlerts([{ variant: "danger", message: t(`error.permissionDenied`) }]);
                setNoPermission(true);
            } else {
                setNoPermission(false);
                if (res.status === 401) {
                    setIsLogged(false);
                } else {
                    const errCode = res.response ? res.response.data.code : res.code ? res.code : res.data ? res.data.code : "cannotFetchData";
                    setAlerts([{ variant: "danger", message: `${t(`error.${errCode}`)}` }]);
                }
            }
            return false;
        }
    };

    useEffect(() => {
        if (isLogged) startSession();
        else {
            clearInterval(interval);
            if (showView) setShowView(null);
        }

        // eslint-disable-next-line
    }, [isLogged]);

    const logout = async (data) => {
        const res = await postMethod("/logout", { data: data });
        if (checkServerData(res)) {
            if (data === "sessionExpired") setSessionAlert({ message: t("session.sessionExpired"), dismissible: true });
            else if (data !== "noAlertActivateAccount" && data !== "noAlertSetNewPassword")
                setAlerts([{ variant: "success", message: t("success.logout"), fading: 1500, id: "logout" }]);
            setIsLogged(false);
            window.scrollTo(0, 0);
        }
    };

    const fetchMainData = async () => {
        const res = await postMethod("/main");
        if (checkServerData(res)) {
            setIsLogged(res.data);
        } else setLoading(false);
    };

    const startSession = () => {
        const loggedTime = Date.now();
        const endSessTime = isLogged.cookieExpDate; //czas w ms kiedy ma zakończyć się sesja

        //jeśli została strona odświeżona w trakcie trwania sesji a także gdy do końca trwania sesji pozostało mniej niż 10 sekund -> wyświetl komunikat
        if (endSessTime - loggedTime <= 10000)
            if (!sessionAlert) {
                const secLeft = Math.round((endSessTime - loggedTime) / 1000);
                setSessionAlert({
                    message: `${t("session.in")} ${secLeft} ${
                        secLeft <= 4 && secLeft >= 2 ? t("session.seconds2") : secLeft === 1 ? t("session.seconds1") : t("session.secondsMore")
                    } ${t("session.sessionWillExpire")}`,
                    dismissible: false,
                });
            }

        interval = setInterval(() => {
            const now = Date.now();
            const leftTime = endSessTime - now;
            let secLeft = Math.round(leftTime / 1000);
            if (leftTime <= 0) {
                //sesja wygasła
                setAlerts([]);
                logout("sessionExpired");
            } else if (leftTime <= 10000)
                setSessionAlert({
                    message:
                        leftTime > 1000
                            ? `${t("session.in")} ${secLeft} ${
                                  secLeft <= 4 && secLeft >= 2 ? t("session.seconds2") : secLeft === 1 ? t("session.seconds1") : t("session.secondsMore")
                              } ${t("session.sessionWillExpire")}`
                            : t("session.loggingOut"),
                    dismissible: false,
                });
            else if (leftTime <= 120000 && leftTime > 10000) {
                //sesja jeszcze trwa, ale zostało więcej niż 10 sekund
                setSessionAlert({
                    message: leftTime < 60000 ? t("session.lessThanMinute") : t("session.moreThanMinute"),
                    dismissible: false,
                });
            }
        }, 1000);
    };

    const changeView = (data) => {
        window.scrollTo(0, 0);
        const list = [...viewsHistory];
        list.push(showView);
        setViewsHistory(list);
        setShowView(data);
    };

    const goBack = () => {
        const view = viewsHistory[viewsHistory.length - 1],
            list = [...viewsHistory];
        list.splice(list.length - 1, 1);
        setViewsHistory(list);
        setShowView(view);
    };

    const NOR = 10;

    useEffect(() => {
        if (!localStorage.getItem("acceptCookies") || localStorage.getItem("acceptCookies") === false) setShowCookieAlert(true);
        // eslint-disable-next-line
    }, []);

    return (
        <Router>
            <BasicContext.Provider
                value={{
                    alerts,
                    setAlerts,
                    setTheme,
                    theme,
                    checkServerData,
                    setIsLogged,
                    changeView,
                    setShowView,
                    showView,
                    goBack,
                    noPermission,
                    logout,
                    interval,
                    setShowLogoutModal,
                    setLoading,
                    loading,
                    fetchMainData,
                    isLogged,
                    viewsHistory,
                    NOR,
                }}
            >
                {sessionAlert && <SessionAlert sessionAlert={sessionAlert} onCloseAlert={setSessionAlert} />}
                {alerts.length > 0 ? <AlertsContainer /> : null}
                {loading && <LoadingView />}
                <Routes>
                    {routes.map((e, i) => (
                        <Fragment key={i}>
                            <Route path={e.path} element={e.element} />
                        </Fragment>
                    ))}
                </Routes>
            </BasicContext.Provider>

            <FooterMain />
            {showLogoutModal && (
                <ConfirmModal
                    show={true}
                    onClose={() => setShowLogoutModal(false)}
                    text={t("logoutModal.txt")}
                    proceedTxt={t("logoutModal.proceedTxt")}
                    cancelTxt={t("logoutModal.cancelTxt")}
                    onProceed={() => {
                        logout("logout from modal");
                        setShowLogoutModal(false);
                    }}
                    title={t("logoutModal.title")}
                />
            )}
            {showCookieAlert && (
                <Alert className="fixed-bottom mb-0 small" id="alertCookie">
                    <p>{t("alertCookie")}</p>

                    <Button
                        size="sm"
                        className="m-2"
                        variant="primary"
                        onClick={() => {
                            setShowCookieAlert(false);
                            localStorage.setItem("acceptCookies", true);
                        }}
                    >
                        {t("understand")}
                    </Button>
                </Alert>
            )}
        </Router>
    );
};

export default App;
